import React from 'react';
import {
  FDLozenge, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';

export const ProductTags = ({ resource, value = [], color }) => {
  const { pageContentResource } = usePageContentContext();

  const isSelected = pageContentResource.attr('product') === resource.id();
  const lozengeColor = color ?? (isSelected ? 'success' : 'info');

  return (
    <FDStack alignItems={'center'} spacing={2} wrap height={20}>
      {value?.map((tag) => <FDLozenge key={tag} label={tag.slice(0, 32)} color={lozengeColor} size={'lg'} />)}
    </FDStack>
  );
};

ProductTags.propTypes = {
  value: PropTypes.array,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  color: PropTypes.string,
};
